import "./ToastProvider.scss";

import type { ReactNode } from "react";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import { MdClose } from "react-icons/md";

const toastDefaults = {
  duration: 4000,
  position: "top-right" as const,
};

/**
 * Renders the toast container. Use `toast()` from 'react-hot-toast' anywhere to show toasts.
 */
export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
        <Toaster
          position={toastDefaults.position}
          containerStyle={{
            top: "4.5rem",
            right: "1rem",
          }}
          containerClassName="app-toast-container"
          toastOptions={{
            duration: toastDefaults.duration,
            style: {
            background: "var(--surface)",
            color: "var(--text)",
            border: "1px solid var(--border)",
            },
          }}
        >
          {(currentToast) => (
            <ToastBar toast={currentToast}>
              {({ icon, message }) => (
                <div className="app-toast">
                  <span className="app-toast__icon">{icon}</span>
                  <span className="app-toast__message">{message}</span>
                  <button
                    className="app-toast__dismiss"
                    type="button"
                    onClick={() => toast.dismiss(currentToast.id)}
                    aria-label="Dismiss notification"
                  >
                    <MdClose />
                  </button>
                </div>
              )}
            </ToastBar>
          )}
        </Toaster>
      </>
    );
}
